module.exports = __webpack_public_path__ + "static/media/zapier image-Photoroom.9cd35e82.png";